import { Box, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useNotify, useTranslate } from "react-admin";
import { CopyToClipboard } from "react-copy-to-clipboard";

const useStyles = makeStyles({
	box: {
		maxWidth: 120,
		whiteSpace: "break-spaces",
	},
	typography: {
		textDecoration: "none",
	},
});

const UserField = ({
	source,
	record,
	basePath,
	sortable,
	sortBy,
	...props
}) => {
	const user = get(record, source);
	const email = get(record, "user.email");
	const notify = useNotify();
	const translate = useTranslate();
	const classes = useStyles();
	const small = useMediaQuery((theme) => theme.breakpoints.between("sm", "lg"));
	return (
		<Box className={small ? classes.box : ""}>
			<CopyToClipboard
				text={email}
				onCopy={() => notify(translate("ra.action.content_copied"))}
			>
				<Typography
					component="a"
					href={`mailto:${email}`}
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
					}}
					color="primary"
					variant="body2"
					className={classes.typography}
					{...props}
				>
					{user}
				</Typography>
			</CopyToClipboard>
		</Box>
	);
};
export default UserField;
